export const successMessage =
  'Request submitted! Someone from our team will reach out soon.';

export const successMessageForDownloadForm =
  'Success! You can now access the Guidebook.';

export const errorMessage = '*Form Submission Failed: Please try again.';

export const submitButtonLabel = 'Submit';

export const nextButtonLabel = 'Next';

export const backButtonLabel = 'Back';

export const guidebookUrl =
  'https://78fb0754.flowpaper.com/Feb2025GBDigital/#DisablePreview=true';

export const guidebookLinkText = 'View the Guidebook';
